/**
 * @generated SignedSource<<660b997737b1e067275da123643bdbbe>>
 * @relayHash 5697e0abe1263b5300c505ca404b81c1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 613ba47d392048aee86ae627f6146fedff60219a2787237cc590eb30208f746c

import type { ConcreteRequest } from 'relay-runtime';
export type ContentRepresentation = "ATLAS_DOC_FORMAT" | "EDITOR" | "EDITOR2" | "EXPORT_VIEW" | "PLAIN" | "RAW" | "STORAGE" | "STYLED_VIEW" | "VIEW" | "WIKI" | "%future added value";
export type UpdateCommentInput = {
  commentBody: CommentBody;
  commentId: string;
  version?: number | null;
};
export type CommentBody = {
  representationFormat: ContentRepresentation;
  value: string;
};
export type EditCommentUpdateCommentMutation$variables = {
  includeVersionFields?: boolean | null;
  input: UpdateCommentInput;
};
export type EditCommentUpdateCommentMutation$data = {
  readonly updateComment: {
    readonly body?: {
      readonly value: string;
    };
    readonly id: string;
    readonly version?: {
      readonly by: {
        readonly displayName: string | null;
      } | null;
      readonly number: number | null;
      readonly when: string | null;
    };
  } | null;
};
export type EditCommentUpdateCommentMutation = {
  response: EditCommentUpdateCommentMutation$data;
  variables: EditCommentUpdateCommentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeVersionFields"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "id"
},
v4 = {
  "args": [
    {
      "kind": "Literal",
      "name": "representation",
      "value": "ATLAS_DOC_FORMAT"
    }
  ],
  "concreteType": "DocumentBody",
  "kind": "LinkedField",
  "name": "body",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "value"
    }
  ],
  "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
},
v5 = {
  "kind": "ScalarField",
  "name": "number"
},
v6 = {
  "kind": "ScalarField",
  "name": "when"
},
v7 = {
  "kind": "ScalarField",
  "name": "displayName"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "EditCommentUpdateCommentMutation",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "updateComment",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "condition": "includeVersionFields",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              (v4/*: any*/),
              {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "by",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "EditCommentUpdateCommentMutation",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "updateComment",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "condition": "includeVersionFields",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              (v4/*: any*/),
              {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "by",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      (v7/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "5697e0abe1263b5300c505ca404b81c1",
    "id": "613ba47d392048aee86ae627f6146fedff60219a2787237cc590eb30208f746c",
    "metadata": {},
    "name": "EditCommentUpdateCommentMutation",
    "operationKind": "mutation",
    "text": "mutation EditCommentUpdateCommentMutation($input:UpdateCommentInput!,$includeVersionFields:Boolean=false){updateComment(input:$input){id,body(representation:ATLAS_DOC_FORMAT)@include(if:$includeVersionFields){value}\n    version@include(if:$includeVersionFields){number,when,by{__typename,displayName}}}}"
  }
};
})();

(node as any).hash = "47ab6347755394e66a03dca4de4caa26";

export default node;
